import { formatDate } from "src/shared/Format/dateFormat";

const TableDateFromat = (value) => {
  return (
    <td className="py-2">
      <span>{value === null ? "" : formatDate(value)}</span>
    </td>
  );
};
export default TableDateFromat;
